
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useParams, MESSAGES } from './../../common/helper/common-imports.component.js'; 
import { FormField, SelectField } from './../../common/helper/formFields';
import {initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import {AgentsService,ConfigService} from "../../../services/index.js";


const EditAgent = () => { 
    const [loading, setLoading] = useState(false);
  const [formData,setFormData] = useState({});
  const [errors, setErrors] = useState({ ...initialErrors });
  const gender = [{ label : 'Male', value : 'M'},{label : 'Female',value : 'F'}]
  const [formDataPersonal, setFormDataPersonal] = useState({ });
  const [statesData, setStatesData] = useState([]);
  const [city,setCity] = useState([]);
  const [passwordChange, setPasswordChange] = useState({});
  const navigate = useNavigate();
  const [limitGroup, setLimit] = useState([]);
  const [commGroup, setCommGroup] = useState([]);

  const { id,customer_id } = useParams();
  const fetchData = async () => {
    try {
      setLoading(true);
      const [statesResponse, agentResponse,commResponse, limitResponse] = await Promise.all([
        ConfigService.getStates(),
        AgentsService.getAgentDetails(id),
        ConfigService.getCommGroups('AGENT',customer_id),
        ConfigService.getLimitGroups(),
      ]);
      const states =  statesResponse.data.data.map(state => ({ value: state.id, label: state.state }));
      const agent = agentResponse.data.data
      const limit =  limitResponse.data.data.map(record => ({ value: record.key, label: record.value, is_default: record.is_default }));
      const comm =   commResponse.data.data.map(record => ({ value: record.key, label: record.value, is_default: record.is_default }));
     
      setCommGroup(comm);
      setLimit(limit)
      updateBasic(agent);
      setStatesData(states)
      getCities(agent.address.state_id,agent);
      setLoading(false);
    } catch (error) {
      setLoading(false);

    }
  };

  const getCities = (stateID, agent) => {
    setLoading(true);
    ConfigService.getCities(stateID)
      .then(response => {
        const cities =  response.data.data.map(city => ({ value: city.id, label: city.city }));
        setCity(cities)
        setAddressInfo(agent);
        setLoading(false);
      })
      .catch(error => {

        setLoading(false);

      });
  }


  const setAddressInfo = (data) => {

    const address = {
        addressLine1: data.address.address1,
        addressLine2: data.address.address2,
        city: data.address.city_id,
        state: data.address.state_id,
        postalCode: data.address.zip
    }
    setFormDataPersonal(address);
  }
  const updateBasic = (userData) => {
    const inputDate = userData.date_of_birth; 
    const parts = inputDate.split('-');
    const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
    const data = {
      "fullName": userData.full_name,
      "email": userData.email_address,
      "phoneNumber": userData.mobile_number,
      "datofBirth": formattedDateOfBirth,
      "gender": userData.gender_id,
      "nationalID": userData.national_id || '',
      "agentID" : userData.agent_id,
      "comm_grp_id":userData.comm_grp_id,
      "limit_group_id": userData.limit_group_id
    }
    setFormData(data)
  }
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  }
  const validateField = (fieldName, value) => {
    let errorMessage = fieldValidation(fieldName, value);
    if (fieldName === 'confirmationPassword') {
    if (value && value !== passwordChange.new_password) {
      errorMessage = 'Password and confirm password not matched';
    } 
  }
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };
  const handleChangeAddress = (e) => {
    const { name, value } = e.target;
    setFormDataPersonal((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    if (name === 'state') {
      getCities(value);
    }
  }

  const handleChangePassword = (e) => {
    const { name, value } = e.target;
    setPasswordChange((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    // if (name === 'newPassword') {
    //   validateField('confirmationPassword', passwordChange.confirmationPassword);
    // }
  }

  const updateBasicInfo = (e) => {
    e.preventDefault();
    
    Object.keys(formData).forEach((fieldName) => validateField(fieldName, formData[fieldName]));
    console.log(formData)
    const hasErrors = Object.entries(formData).some(([key, value]) => {
        if (key === "nationalID") return false;
        return value === '';
    });
    if(!hasErrors){

        setLoading(true);
        const inputDate = formData.datofBirth; 
        const parts = inputDate.split('-');
        const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
        const dataToupdate = {
          "profile_detail" : {
            "full_name": formData.fullName,
            "user_id": id,
            "email_address": formData.email,
            "mobile_number": formData.phoneNumber,
            "date_of_birth": formattedDateOfBirth,
            "gender_id": formData.gender,
            "national_id": formData.nationalID,
            "comm_grp_id":formData.comm_grp_id,
            "limit_group_id": formData.limit_group_id
            }
          }
          updateAgentProfile(dataToupdate)
        }
  }

  const updateAddress = (e) => {
    e.preventDefault();
    const hasErrors =  Object.values(formDataPersonal).some(value => value === '');
        if(!hasErrors){
            const dataToupdate = {
                address_detail:{
                    address1: formDataPersonal.addressLine1,
                    address2: formDataPersonal.addressLine2,
                    city_id:formDataPersonal.city,
                    state_id: formDataPersonal.state,
                    zip: formDataPersonal.postalCode,
                }
            }
            updateAgentProfile(dataToupdate)
          }
  }

  const updateAgentProfile = (data) => {
    AgentsService.updateAgentProfile(id,data)
          .then(response => {
            setLoading(false);
            navigate('/agents')
            toast.success(MESSAGES.AGENT_UPDATED)
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
  }
  const back = () => {
    navigate(-1); 
  }

    useEffect(() => {
        fetchData();
    // getAgent() //updateBasic(userData.user.data);
      //getStates();
      document.body.style.backgroundImage = '';

        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);

    return (
        <>
            <LoaderOverlay loading={loading} />
            <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
              <h4 className="updatename" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Update Agent</h4>
              <div className="container" style={{backgroundColor: 'white'}}>
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active tbbtn" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Basic Information</button>
                    <button className="nav-link tbbtn" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false" onclick="myFunction()" tabIndex={-1}>Address</button>
                 
                  </div>
                </nav>
                <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
                  <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <form onSubmit={updateBasicInfo}>
                    <div className="panel panel-default">
                      <div className="panel-body" style={{padding: '0px'}}>
                        <div className="col-md-12" style={{padding: 0}}>
                          <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                              {/* <label htmlFor="f_name">AGENT ID</label>
                              <input type="text" className="form-control" id="first_name" defaultValue={2222252524} name="f_name" disabled /> */}
                               <FormField
                                   type="text"
                                   isRequierd = {false}
                                   id="agentID"
                                   name="agentID"
                                   label="AGENT ID"
                                   placeholder = "Enter Agent ID"
                                  
                                   disabled={true.toString()}
                                   value={formData.agentID}
                                   maxLength={20}
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {true}
                                   id="f_name"
                                   name="fullName"
                                   label="FULL NAME"
                                   placeholder = "Enter Full Name"
                                   value={formData.fullName}
                                   onChange={handleChange}
                                   error={errors.fullName}
                                   maxlength = {20}
                                   
                                   
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {true}
                                   id="email"
                                   name="email"
                                   label="EMAIL"
                                   placeholder = "Enter email"
                                   value={formData.email}
                                   onChange={handleChange}
                                   error={errors.email}
                                   disabled={true}
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <SelectField 
                                        id="gender"
                                        isRequierd = {true}
                                        name="gender"
                                        label="GENDER"
                                        selectedField = "Select Gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        error={errors.gender}
                                        options={gender}
                                        />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                          <SelectField 
                            id="limit_group_id"
                            isRequierd = {true}
                            name="limit_group_id"
                            label="Limit GROUP"
                            selectedField = "Select Limit Group"
                            value={formData.limit_group_id}
                            onChange={handleChange}
                            error={errors.limit_group_id}
                            options={limitGroup}
                            />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>
                          </div>
                          <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {false}
                                   id="nationalID"
                                   name="nationalID"
                                   label="NATIONAL ID"
                                   placeholder = "Enter National ID"
                                   value={formData.nationalID}
                                   onChange={handleChange}
                                   maxlength = {15}
                                
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="date"
                                   isRequierd = {true}
                                   id="datofBirth"
                                   name="datofBirth"
                                   label="DATE OF BIRTH"
                                   placeholder = "Enter DOB"
                                   value={formData.datofBirth}
                                   onChange={handleChange}
                                   error={errors.datofBirth}
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {true}
                                   id="phoneNumber"
                                   name="phoneNumber"
                                   label="PHONE NUMBER"
                                   placeholder = "Enter Phone Number"
                                   value={formData.phoneNumber}
                                   onChange={handleChange}
                                   error={errors.phoneNumber}
                                   maxlength = {10}
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                              <label htmlFor="f_name">UPLOAD PHOTO</label>
                              <input style={{width: '80%', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name" />
                              <img src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                          <SelectField 
                            id="comm_grp_id"
                            isRequierd = {true}
                            name="comm_grp_id"
                            label="COMMISSIOM GROUP"
                            selectedField = "Select Commission Group"
                            value={formData.comm_grp_id}
                            onChange={handleChange}
                            error={errors.comm_grp_id}
                            options={commGroup}
                            />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>
                          </div>
                        </div>
                        <br />
                        <div align="left">
                        <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Update</button>
                        </div>
                        <br />
                      </div>
                    </div>
                    </form>
                  </div>
                  <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div className="panel panel-default">
                      <form onSubmit={updateAddress}>
                      <div className="panel-body" style={{padding: '0px'}}>
                        <div className="col-md-12" style={{padding: 0}}>
                          <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {true}
                                   id="addressLine1"
                                   name="addressLine1"
                                   label="ADDRESS LINE 1"
                                   placeholder = "Enter Address"
                                   value={formDataPersonal.addressLine1}
                                   onChange={handleChangeAddress}
                                   error={errors.addressLine1}
                                   maxlength = {50}
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                              
                              <SelectField 
                               id="state"
                               isRequierd = {true}
                               name="state"
                               label="STATE"
                               selectedField = "Select State"
                               value={formDataPersonal.state}
                               onChange={handleChangeAddress}
                               error={errors.state}
                               options={statesData}
                            />
                            
                              
                              <span id="error_profile_city" className="text-danger" />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {false}
                                   id="addressLine2"
                                   name="addressLine2"
                                   label="ADDRESS LINE 2"
                                   placeholder = "Enter Address"
                                   value={formDataPersonal.addressLine2}
                                   onChange={handleChangeAddress}
                                   error={errors.addressLine2}
                                   maxlength = {50}
                                />
                              
                            </div>
                          </div>
                          <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <SelectField 
                               id="city"
                               isRequierd = {true}
                               name="city"
                               label="CITY"
                               selectedField = "Select City"
                               value={formDataPersonal.city}
                               onChange={handleChangeAddress}
                               error={errors.city}
                               options={city}
                            />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {true}
                                   id="postalCode"
                                   name="postalCode"
                                   label="POSTAL CODE"
                                   placeholder = "Enter Postal Code"
                                   value={formDataPersonal.postalCode}
                                   onChange={handleChangeAddress}
                                   error={errors.postalCode}
                                   maxLength = {6}
                                />
                            </div>
                            {/* <div className="form-group frm" style={{textAlign: 'left'}}>
                              <label className="required" htmlFor="email">POSTAL CODE</label>
                              <input type="email" className="form-control" id="profile_postal_code" placeholder="Enter Postal Code" name="email" />
                              <span id="error_profile_postal_code" className="text-danger" />
                            </div> */}
                          </div>
                        </div>
                        <br />

                        <div align="left">
                          
                        <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Update</button>
                        </div>
                        <br />
                      </div>
                      </form>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            </>
          );
        
        }
       
          function mapStateToProps(state) {
            const userData = state.authReducer.user;
            return { userData };
          }
        export default withAuth(connect(mapStateToProps)(EditAgent));